import React from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";

import Chart from "chart.js";
const fontFamily =
  '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"';

function ReceivablesChart({ infos }) {
  const chartRef = React.useRef(null);

  const data = React.useMemo(() => {
    return {
      type: "horizontalBar",
      data: {
        datasets: [
          {
            backgroundColor: ["#F0166D"],
            label: "Clientes em Atraso",
            data: [infos?.overdueCustomers],
            barPercentage: 0.6,
            borderWidth: 0,
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            align: "end",
            anchor: "end",
            backgroundColor: function (context) {
              return "white";
            },
            borderColor: function (context) {
              return "#000";
            },
            borderWidth: 1,
            borderRadius: 4,
            color: "black",
            font: {
              family: fontFamily,
              size: 12,
            },
            // formatter: formatterCallback,
            padding: {
              top: 4,
              bottom: 2,
              left: 6,
              right: 6,
            },
          },
        },

        layout: {
          padding: {
            top: 0,
            right: 60,
            bottom: 0,
            left: 16,
          },
        },
        legend: {
          align: "start",
          position: "bottom",
        },
        tooltips: {
          enabled: false,
        },
        scales: {
          xAxes: [
            {
              fontFamily: fontFamily,
              scaleLabel: {
                fontFamily: fontFamily,
              },

              ticks: {
                fontFamily: fontFamily,
                beginAtZero: true,
              },
            },
          ],
          yAxes: [
            {
              fontFamily: fontFamily,
              scaleLabel: {
                fontFamily: fontFamily,
              },

              ticks: {
                fontFamily: fontFamily,
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  }, [infos]);

  React.useEffect(() => {
    new Chart(chartRef.current, data);
  }, [data]);

  return <canvas style={{ maxHeight: 250 }} ref={chartRef} />;
}

export default ReceivablesChart;
